export function exists(value) {
  return !!value && !["undefined", "null"].includes(value);
}
